// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1WZKY","title":"Images90_title__2duh3","images":"Images90_images__2nuXL"};